module.exports = __webpack_public_path__ + "img/crewFamilyXmasParty16.48eec907.jpg";